'use client';

import { useModalAlertStore } from '@/stores/useModalAlertStore';
import ModalAlert from '@/components/modal/ModalAlert';

export default function ModalAlertWrapper() {
    const { isOpen, currentAlert, closeModalAlert } = useModalAlertStore();

    return (
        <ModalAlert
            isOpen={isOpen}
            onClose={closeModalAlert}
            message={currentAlert?.message ?? ''}
            subMessage={currentAlert?.subMessage}
            confirmLabel={currentAlert?.confirmLabel}
            cancelLabel={currentAlert?.cancelLabel}
            onAlert={currentAlert?.onAlert ?? (() => {})}
            onCancel={currentAlert?.onCancel}
            variant={currentAlert?.variant}
        />
    );
}
